import type { ApiError } from '@shared/types';

/**
 * Normalize a non-2xx Response into an ApiError.
 * Tries to parse the body as JSON matching the error envelope;
 * falls back to a synthetic error built from the HTTP status.
 */
export async function normalizeError(response: Response): Promise<ApiError> {
  try {
    const body: unknown = await response.json();
    if (isApiError(body)) {
      return body;
    }
  } catch {
    // body is not JSON — fall through to synthetic error
  }

  return {
    code: `HTTP_${response.status}`,
    message: response.statusText || 'Unknown error',
    correlationId: response.headers.get('x-correlation-id') ?? '',
  };
}

function isApiError(value: unknown): value is ApiError {
  return (
    typeof value === 'object' &&
    value !== null &&
    'code' in value &&
    'message' in value &&
    'correlationId' in value
  );
}
